module.exports = __webpack_public_path__ + "img/FR11989.344b9f6f.png";